export enum PosStateCode {
  OK = 1,
  ERROR = 0,
}
